import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import './AdminLayout.css';

function AdminLayout() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('admin_token');
    const userData = localStorage.getItem('admin_user');

    if (!token || !userData) {
      navigate('/admin/login');
      return;
    }

    setUser(JSON.parse(userData));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/admin/login');
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="admin-layout">
      <nav className="admin-nav">
        <div className="admin-nav-header">
          <h1>ALL-ACCESS Admin</h1>
          <p className="admin-user-info">{user.email}</p>
        </div>

        <ul className="admin-nav-links">
          <li>
            <NavLink
              to="/admin/trades"
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              📊 Manage Trades
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/product-settings"
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              ⚙️ Product Settings
            </NavLink>
          </li>
        </ul>

        <div className="admin-nav-footer">
          <NavLink to="/" className="admin-nav-link-home">
            🏠 View Dashboard
          </NavLink>
          <button onClick={handleLogout} className="admin-logout-btn">
            Logout
          </button>
        </div>
      </nav>

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
